var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-select-wrap"},[_vm._l((_vm.list),function(item,index){return [_c('div',{key:index,staticClass:"time-item",class:{
        disabled: item.value === 1,
        selected: item.index >= _vm.startIndex && item.index <= _vm.endIndex,
      },on:{"click":function($event){return _vm.handleClickItem(item)}}},[_c('span',{staticClass:"time-item-text"},[_vm._v(_vm._s(item.label))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }